// Modules
import type {GetStaticProps} from 'next';
import {serverSideTranslations} from '@app/modules/locale-management/server';
import {LandingSections} from '@tempo/landing';
import Accessibility from '@app/views/accessibility';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';
import {useTranslation} from '@app/hooks/use-translation';

const AccessibilityPage: React.FC<LandingProps> = (props) => {
	const {t} = useTranslation({ns: ['accessibility']});
	const pageTitle = t('footer_title_accessibility_web');
	const pageDescription = t('accessibilityact_text_maindescription_web');
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections topGutter px="spacing.xl">
				<Accessibility {...props} platform="web" />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'common',
		'accessibility',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
		},
		revalidate: 15 * 60,
	};
};

export default AccessibilityPage;
